import { REACT_APP_API } from "config";

// const token =
//   "udUJsGktQe4mE2lH5y5YCrTPiZScpX0ei5YHpdqRB0jfK9fzCUMw1fpE5UV72fm4";

export default class Fetcher {
  get(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      credentials: "include",
      headers: {
        "content-type": "application/json",
        "accept-encoding": "gzip, deflate",
        // "auth-server-token": token,
      },
      method: "GET",
    });
  }

  post(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: JSON.stringify(request.body),
      credentials: "include",
      headers: {
        "content-type": "application/json",
        // "auth-server-token": token,
      },
      method: "POST",
    });
  }

  data(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: request.body,
      credentials: "include",
      headers: {
        // "auth-server-token": token,
      },
      method: "POST",
    });
  }

  delete(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: JSON.stringify(request.body),
      credentials: "include",
      headers: {
        "content-type": "application/json",
        // "auth-server-token": token,
      },
      method: "DELETE",
    });
  }

  put(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: JSON.stringify(request.body),
      credentials: "include",
      headers: {
        "content-type": "application/json",
        // "auth-server-token": token,
      },
      method: "PUT",
    });
  }
}
